module.exports = __webpack_public_path__ + "media/images/timer-piece-b5402836.png";